<template>
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.2"
      cx="27"
      cy="27"
      r="27"
      fill="#0F285B"
    />
    <circle
      opacity="0.2"
      cx="27"
      cy="27"
      r="21.3047"
      fill="#0F285B"
    />
    <circle
      cx="27"
      cy="27"
      r="12.6562"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.3438 27V39.6562H27C33.9898 39.6562 39.6562 33.9898 39.6562 27C39.6562 20.0102 33.9898 14.3438 27 14.3438C20.0102 14.3438 14.3438 20.0102 14.3438 27ZM26.209 25.418H27.791V31.7461H26.209V25.418ZM26.209 22.6494H27.791V24.2314H26.209V22.6494Z"
      fill="#0F285B"
    />
  </svg>
</template>
